var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.912 3.443a1 1 0 0 1 1.499 1.32l-.083.094-6.21 6.22a3.988 3.988 0 0 0-1.162 2.605l-.006.228v2.94c0 1.052.817 1.918 1.85 1.994l.15.006h2.94c.991 0 1.939-.36 2.67-1.005l.176-.165 4.433-4.403 2.709-2.666.323-.314.038-.034.093-.099a2.946 2.946 0 0 0-.016-3.876l-.224-.232a2.877 2.877 0 0 0-3.94-.079l-.137.132-7.036 7.197.001 1.594 1.596-.002-.003.004 6.39-6.38a1 1 0 0 1 1.497 1.322l-.083.094-6.41 6.398a2.06 2.06 0 0 1-1.225.556l-.172.008H7.98a1.996 1.996 0 0 1-1.995-1.85l-.005-.15v-1.59c0-.482.166-.948.46-1.288l.115-.121 7.026-7.186c1.819-1.88 4.784-1.973 6.736-.25l.21.198.068.068a4.944 4.944 0 0 1 .024 6.984l-.039.037-.055.045-2.204 2.165-5.188 5.149a6.023 6.023 0 0 1-3.963 1.733l-.28.006H5.95a4.003 4.003 0 0 1-3.995-3.8l-.005-.2v-2.94c0-1.504.556-2.942 1.559-4.044l.193-.203 6.21-6.22z",
    fill: "#1B3DF2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAttachment);
export default __webpack_public_path__ + "static/media/icons-attachment.426f4e1a50d83abdcc8c44d188a5a9d8.svg";
export { ForwardRef as ReactComponent };